export function formatAdminCommerceCost(value: number | undefined): string {
  const normalized = Number.isFinite(value) ? (value ?? 0) : 0;
  if (normalized === 0 || Math.abs(normalized) >= 0.0001) {
    return `$${normalized.toFixed(4)}`;
  }

  const trimmed = normalized.toFixed(12).replace(/0+$/, '').replace(/\.$/, '');
  const [whole, fraction = ''] = trimmed.split('.');
  return `$${whole}.${fraction.padEnd(4, '0')}`;
}
